import mainTheme from "@irati/ui/src/global/theme"
import {Body} from "@irati/ui/src/Typography"
import styled from "styled-components"

export const Content = styled.div<{color?: string}>`
  ${({theme, color = mainTheme.colors.utility.white}) => `
    h2,
    ${Body} {
      text-align: left
      color: ${color || theme.colors.utility.white};
    }
    `}
`

export const Description = styled(Body)`
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 810px;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;

  @supports not ((display: -webkit-box) and (-webkit-line-clamp: 2)) {
    max-height: 44px;
  }
`
